import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ShiftHandoverNotesMode } from '../enum/shiftHandoverNotesMode';
import { ShiftHandoverCountRequest } from '../dto/notes/shiftHandoverCountRequest';

@Injectable({ providedIn: 'root' })
export class IntershiftMessageService {
  private api = '/api/IntershiftMessage';
  constructor(private http: HttpClient) {}

  getTotal(unreadOnly: boolean): Observable<number> {
    let request = new ShiftHandoverCountRequest();
    request.unreadOnly = unreadOnly;

    if (+sessionStorage.getItem('notesMode') === ShiftHandoverNotesMode.Workplan) {
      request.residentsIds = JSON.parse(sessionStorage.getItem('workplanResidents')) ?? [];
    }

    return this.http.post(this.api + '/Intershift/Total', request).pipe(map((val) => +val));
  }

  getMustReadNotesMessages(): Observable<number>{
    let request = new ShiftHandoverCountRequest();
    request.unreadOnly = true;

    if (+sessionStorage.getItem('notesMode') === ShiftHandoverNotesMode.Workplan) {
      request.residentsIds = JSON.parse(sessionStorage.getItem('workplanResidents')) ?? [];
    }
    return this.http.post<number>(this.api + '/MustReadNotesMessages', request);
  }
}
